<template lang="html">
  <div :class="{ 'show-picker-active': show_picker }" class="mb-3">
    <p v-if="label != ''" class="pt-0 mb-0 small">
      {{ label }}
      <span class="color-swatch" @click="showPicker">
        <span :style="swatch_style" class="swatch-color" />
        <span v-if="!active" class="diagonal" />
        <checkboard class="checkboard" />
      </span>

      <b-link
        v-if="active && optional"
        class="ml-2"
        @click="
          _active = false;
          hidePicker();
        "
      >
        Remove
      </b-link>
    </p>
    <div
      v-if="show_picker"
      :class="{
        sketch: showAdvancedTextColorPicker,
        compact: !showAdvancedTextColorPicker
      }"
      class="picker"
    >
      <p>{{ label }}</p>
      <compact-picker
        v-if="!showAdvancedTextColorPicker"
        :value="_value"
        class="compact-picker"
        @input="
          c => {
            updateColor(c);
          }
        "
      />
      <sketch-picker
        v-if="showAdvancedTextColorPicker"
        :value="_value"
        class="sketch-picker"
        @input="
          c => {
            updateColor(c);
          }
        "
      />
      <b-link
        v-if="!user_requests_advanced_picker"
        variant="outline-dark"
        class="mt-1 small ml-2 float-left"
        :disabled="!isCompactColor(_value)"
        @click="user_requests_advanced_picker = !user_requests_advanced_picker"
      >
        More colors
      </b-link>
      <b-link
        v-if="user_requests_advanced_picker && isCompactColor(_value)"
        variant="outline-dark"
        class="mt-1 small ml-2 float-left"
        :disabled="!isCompactColor(_value)"
        @click="user_requests_advanced_picker = !user_requests_advanced_picker"
      >
        Less colors
      </b-link>
      <b-link
        variant="success"
        class="mt-1 small mr-3 float-right"
        @click="hidePicker"
      >
        Close
      </b-link>
    </div>
  </div>
</template>

<script>
import Sketch from "./vue-color/components/Sketch";
import Compact from "./vue-color/components/Compact";
import { Checkboard } from "vue-color";
import tinycolor from "tinycolor2";
import sortBy from "lodash/sortBy";
export default {
  name: "ColorPicker",
  components: {
    "sketch-picker": Sketch,
    "compact-picker": Compact,
    checkboard: Checkboard
  },
  props: {
    value: {
      type: String,
      default: () => {
        return "rgba(0,0,0,1)";
      }
    },
    active: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    label: {
      type: String,
      default: () => ""
    },
    optional: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      show_picker: false,
      show_advanced_picker_swatches: false,
      user_requests_advanced_picker: false,
      compactColors: [
        "#333333FF",
        "#999999FF",
        "#FFFFFFFF",
        "#F44E3BFF",
        "#FE9200FF",
        "#FCDC00FF",
        "#DBDF00FF",
        "#A4DD00FF",
        "#68CCCAFF",
        "#73D8FFFF",
        "#AEA1FFFF",
        "#FDA1FFFF",
        "#000000FF",
        "#808080FF",
        "#CCCCCCFF",
        "#D33115FF",
        "#E27300FF",
        "#FCC400FF",
        "#B0BC00FF",
        "#68BC00FF",
        "#16A5A5FF",
        "#009CE0FF",
        "#7B64FFFF",
        "#FA28FFFF",
        "#00000000",
        "#555555FF",
        "#B3B3B3FF",
        "#9F0500FF",
        "#C45100FF",
        "#FB9E00FF",
        "#808900FF",
        "#194D33FF",
        "#0C797DFF",
        "#0062B1FF",
        "#653294FF",
        "#AB149EFF"
      ]
    };
  },
  computed: {
    showAdvancedTextColorPicker() {
      // Advanced picker is shown if color requires it, or user has engaged it.
      return (
        this.user_requests_advanced_picker ||
        !this.isCompactColor(this.rgba_string)
      );
    },
    _value: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("changed", value);
      }
    },
    _active: {
      get() {
        return this.active;
      },
      set(value) {
        if (!value) {
          this.$emit("deactivated");
        }
      },
      advancedColors() {
        if (this.show_advanced_picker_swatches) {
          return this.compactColors;
        }
        return [];
      }
    },
    swatch_style() {
      var active_color = this.value;
      if (!this.active) {
        active_color = "white";
      }
      return {
        "background-color": active_color
      };
    }
  },
  watch: {
    rgba_string() {
      if (!this.user_requests_advanced_picker) {
        // Once the advanced color is engaged, leave it engaged.
        this.user_requests_advanced_picker = !this.isCompactColor(
          this.rgba_string
        );
      }
    }
  },
  activated() {},
  mounted() {
    this.compactColors = sortBy(this.compactColors, c => {
      return tinycolor(c).getLuminance();
    });
  },
  methods: {
    showPicker() {
      console.log("showPicker");
      this.show_picker = true;
      document.addEventListener("click", this.handleOutsideClick);
      document.addEventListener("touchstart", this.handleOutsideClick);
    },
    hidePicker() {
      console.log("hidePicker");
      this.show_picker = false;
      document.removeEventListener("click", this.handleOutsideClick);
      document.removeEventListener("touchstart", this.handleOutsideClick);
    },
    updateColor(value) {
      this._value = `rgba(${value.rgba.r}, ${value.rgba.g}, ${value.rgba.b}, ${value.rgba.a})`;
    },
    isCompactColor(rgba_string) {
      var _color = tinycolor(rgba_string);
      return (
        this.compactColors.includes(_color.toHex8String().toUpperCase()) &&
        _color.getAlpha() == 1
      );
    },
    handleOutsideClick(event) {
      console.log("handleOutsideClick");
      var el = this.$el;
      var clickOutsideThisElement = !(
        el == event.target || el.contains(event.target)
      );
      if (this.show_picker && clickOutsideThisElement) {
        this.hidePicker();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.show-picker-active {
  z-index: 10001 !important;
}
.picker {
  position: absolute;
  top: -10px;
  left: 8px;
  width: 100%;
  height: auto;
  padding-top: 6px;
  padding-bottom: 10px;
  padding-left: 10px;
  background-color: white;
  border-radius: 0.2em;
  box-shadow: 0 2px 18px rgba(0, 0, 0, 0.2), 0 2px 5px rgba(0, 0, 0, 0.3);
  z-index: 102;
  p {
    margin-left: 6px;
    height: 5px;
    font-size: 0.9em;
  }
}
.compact {
  width: 270px;
}
.sketch {
  width: 234px;
}
.compact-picker {
  margin-top: -1px;
  margin-left: 2px;
}
.sketch-picker {
  margin-top: -6px;
  margin-left: -3px;
}
.color-swatch {
  position: relative;
  margin-left: 3px;
  bottom: -3px;
  overflow: hidden;
  display: inline-block;
  width: 20px !important;
  height: 20px !important;
  border: solid 1px black;
  cursor: pointer;
  .swatch-color {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 100;
  }
  .diagonal {
    left: 6px;
    top: -16px;
    width: 32px;
    height: 32px;
    border-bottom: 1px solid red;
    -webkit-transform: rotate(45deg);
    position: absolute;
    z-index: 101;
    /* top: -20px; */
  }
}
</style>
